import { session_skey } from "@tencent/midas-util"

export class SkeyAccount {
  init(opt) {
    return new Promise((resolve, reject) => {
      if (opt.openid && opt.openkey) {
        let loginState = new session_skey({
          uin: opt.openid,
          skey: opt.openkey
        })
        resolve({ loginState: loginState })
      } else {
        reject("无登录态")
      }
    })
  }
}
